/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'reactstrap';
import {
  MdLightbulbOutline,
  MdDone,
  MdEdit,
  MdSettings,
  MdDescription,
} from 'react-icons/md';

const Card = (props) => {
  return (
    <div className="card card-price">
      <div className="content">
        <h4 className="title-header">
          {props.phase}
          <br />
          <small className="subtitle-header">
            {props.icon} {props.title}
          </small>
        </h4>
        <div className="price">
          {props.type === 1 ? <i className="fa fa-dollar" /> : ''}
          <div className="number text-danger">{props.price}</div>
        </div>
        <p className="text-description">
          <ul className="text-left">
            {props.description.map((d) => (
              <li>{d}</li>
            ))}
          </ul>
        </p>
        <div className="text-center">
          <a href={props.url} target="_blank">
            <button type="button" className="btn btn-danger btn-round btn-fill">
              Solicitar
            </button>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Card;
